import access from "../access.json";

// const roles = ["admin", "superadmin"];
// const action = "place_departments_add";

const haveAccess = (roles, action) => {
  if (roles && action) {
    for (let i = 0; i < roles.length; i++) {
      const roleAccess = access[roles[i]];
      if (Array.isArray(roleAccess) && roleAccess.includes(action)) {
        return true;
      } else if (typeof roleAccess == "string" && roleAccess == action) {
        return true;
      } else if (
        typeof roleAccess == "object" &&
        Object.values(roleAccess).includes(action)
      ) {
        return true;
      }
    }
  }
  return false;
};

export default haveAccess;
